const stage = process.env.VERCEL_ENV || process.env.stage || "development";
const shouldTrack = stage !== "development";

// Track analytics of report generation
export function track(eventName: string, eventInfo: any) {
  if (shouldTrack) {
    //@ts-ignore
    window.analytics.track(eventName, eventInfo);
  }
}

// Identify a user with information
export function identifyWithId(userId: string, userInfo: any) {
  if (shouldTrack) {
    //@ts-ignore
    window?.analytics?.identify(userId, userInfo);
  }
}

// Identify a user with information
export function identify(userInfo: any) {
  if (shouldTrack) {
    //@ts-ignore
    window?.analytics?.identify(userInfo);
  }
}
